import { Component, OnInit, Input, OnChanges, OnDestroy } from '@angular/core';
import { InventoryHighlightService } from './inventory-highlight.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonService } from '../../../../services/common.service';
import { GenericUtils } from '../../../../utilities/generic-utils';

@Component({
  selector: 'inventory-highlight',
  templateUrl: './inventory-highlight.component.html',
  styleUrls: ['./inventory-highlight.component.scss']
})
export class InventoryHighlightComponent implements OnInit, OnChanges, OnDestroy {

  constructor(private service: InventoryHighlightService,
    private commonService: CommonService,
    private genericUtils: GenericUtils) { }

  private unsubscribe: Subject<void> = new Subject();
  @Input() TITLE = "";
  @Input() API = "";
  @Input() TEXT = "";
  @Input() TOTAL = "";
  dataLoading = false;
  data: any;

  ngOnChanges() {
    if (this.TOTAL) {
      this.individualInventory();
    }
    // else {
    //   this.data = '';
    //   this.dataLoading = true;
    // }

  }

  ngOnInit() { }

  individualInventory() {
    this.service.individualInventory(this.API).pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      if (res['data'].length && res['data'][0] && Object.keys(res['data'][0]).length) {
        const calculateValue = {}
        const inventoryListingStorageGroup = res['data'][0]['InventoryListingStorageGroup'];
        calculateValue['percentage'] = (inventoryListingStorageGroup[0]['total_quantity'] / this.TOTAL[0]['total_quantity']) * 100;
        calculateValue['byValue'] = inventoryListingStorageGroup[0]['total_value'];
        this.data = calculateValue;
      } else {
        this.data = '';
        this.dataLoading = true;
      }
    }, error => {
      this.data = '';
      this.dataLoading = true;
    })
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}
